import React from "react";

import Header from "~/public/Header";
import { ReactComponent as NotFoundIllo } from "~/streamsPage/404-illustration.svg";

import styles from "./css/NotFound.module.css";

export default class NotFound extends React.Component {
	render() {
		return (
			<>
				<Header />
				<div className={styles.notFound}>
					<NotFoundIllo />
					<h1>Uh oh, we couldn’t find this item.</h1>
					<p>You may be seeing this because the link expired.</p>
				</div>
			</>
		);
	}
}
